import {useGetVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';

type Props = {
  appId: string;
  compilation_id: number | string;
  compilation_name: string;
  compilation_num: number;
  eventNumber?: string | null;
};
export const useEventsAnalytics = () => {
  const getVkId = useGetVkId();

  const logEventClick = ({
    appId,
    compilation_id,
    compilation_name,
    compilation_num,
    eventNumber,
  }: Props) => {
    logTmrEvent({
      logEvent: 'event.click',
      params: {
        vk_id: getVkId(),
        event_num: eventNumber,
        inner_app_event_name: compilation_name,
        compilation_id,
        compilation_name,
        compilation_num,
        app_id: appId,
      },
    });
  };

  const logEventAppDownloadClick = ({
    appId,
    appName,
  }: {
    appId: string;
    appName: string;
  }) => {
    logTmrEvent({
      logEvent: 'appDownload.click',
      params: {
        vk_id: getVkId(),
        app_name: appName,
        app_id: appId,
      },
    });
  };

  const logEventView = ({
    appId,
    compilation_id,
    compilation_name,
    compilation_num,
  }: Props) => {
    logTmrEvent({
      logEvent: 'event.view',
      params: {
        vk_id: getVkId(),
        inner_app_event_name: compilation_name,
        compilation_id,
        compilation_name,
        compilation_num,
        app_id: appId,
      },
    });
  };

  return {
    logEventAppDownloadClick,
    logEventClick,
    logEventView,
  };
};
